import request from '@/utils/request';

export function getAbnormalList(params) { // 异常反馈列表
  return request({
    url: `/op/application/abnormal/pagelist`,
    method: 'get',
    params: params
  });
}

export function getAppName(params) { // 应用名称列表
  return request({
    url: `/op/application/abnormal/getManagement`,
    method: 'get',
    params: params
  });
}
export function outTable(params) { // 导出列表
  return request({
    url: `/op/application/abnormal/excel`,
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}
